import { Card } from "./Card";
import { CardDescription } from "./CardDescription";
import { Container } from "./Container";

export const FeatureCards = {
  Container,
  Card,
  CardDescription,
};
